import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Box } from '@chakra-ui/react';
import { SiteSettingsContext } from '@repo/contexts/SiteSettingsContext';
import NavSearch from './NavSearch';

function SearchInput({ searchFocusUpdater, toggleMobileMenu, ...props }) {
  const { algoliaSearchSettings } = useContext(SiteSettingsContext);

  const { blogIndexName, productIndexName } = algoliaSearchSettings;

  return (
    <Box pos="relative" {...props}>
      <NavSearch
        searchIndexes={[productIndexName, blogIndexName]}
        hitsPerPage={5}
        searchFocusUpdater={searchFocusUpdater}
        toggleMobileMenu={toggleMobileMenu}
      />
    </Box>
  );
}

SearchInput.defaultProps = {
  toggleMobileMenu: () => {},
  searchFocusUpdater: 1,
};

SearchInput.propTypes = {
  toggleMobileMenu: PropTypes.func,
  searchFocusUpdater: PropTypes.number,
};

export default SearchInput;
